<div class="container fadeIn" *ngIf="productList && productList.length > 0">
  <div class="row">
    <div class="col-12">
      <h2 class="titleTextFont font-weight-normal text-center my-3" style="font-size: 2.4rem;"
        [ngStyle]="{'color': titlesColor ? titlesColor : ''}">
        {{ title }}
      </h2>
    </div>
    <div class="col-12">
      <h2 class="font-weight-normal fadeIn text-center mb-3 subtitle-block" style="font-size: 1.5rem;"
        [ngStyle]="{'color': secondaryColor ? secondaryColor : ''}">
        {{ subtitleText }}
      </h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4 animate__animated animate__fadeIn" *ngFor="let product of productList">
      <div class="courseItem">
        <div class="itemImage hover-shadow">
          <picture>
            <img
              [src]="product?.image"
              loading="lazy"
            />
          </picture>
        </div>
        <div class="itemDetails">
          <p class="itemTitle hover-text-shadow textFont mb-2">{{ product?.name }}</p>
          <div class="row">
            <div class="col" *ngIf="!product.free; else free">
              <p class="text-left text-info font-weight-bold textFont">
                <span class="text-price mr-2">{{ product.price }}</span>
              </p>
            </div>
            <ng-template #free>
              <div class="col">
                <p class="text-left text-info font-weight-bold textFont">
                  Gratis
                </p>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-center" *ngIf="btn1Active || btn2Active">
    <a *ngIf="btn1Active" [href]="btn1Link" class="btn btn-info btn-flex m-2 col-auto">
      {{ btn1Text }}
    </a>
    <a *ngIf="btn2Active" [href]="btn2Link" class="btn btn-info btn-flex col-auto">
      {{ btn2Text }}
    </a>
  </div>
</div>
